"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[827],{

/***/ 7494:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);



window.PSTheme.Vue.Unsubscribe = new (vue__WEBPACK_IMPORTED_MODULE_0___default())({
  name: 'Unsubscribe',

  data() {
    return {
      result: null,
      unsub: null,
      email: null,
      firstname: null,
      lastname: null,
      birthday: null,
      keepSendingCheckbox: false,
      loadingPref: false,
      loadingUnsub: false
    };
  },

  mounted() {
    let url = new URL(location.href);
    this.result = url.searchParams.get('result');
    this.unsub = url.searchParams.get('unsub');
    this.email = url.searchParams.get('email');
    this.firstname = url.searchParams.get('firstname');
    this.lastname = url.searchParams.get('lastname');
    this.birthday = url.searchParams.get('birthday');
  },

  methods: {
    unsubscribe(evt) {
      if (evt.submitter.id == 'unsubscribe_btn') {
        this.loadingUnsub = true;
        this.$refs.unsubscribe.value = true;
        this.$refs.form.submit();
      } else {
        this.loadingPref = true;
        this.$refs.form.submit();
      }
    }

  }
}).$mount('.unsubscribe');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346], function() { return __webpack_exec__(7494); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);